import React from "react";
import { Col, Space } from "antd";

import CarCategoryList from "../../components/CarCategoryList";
import CarModelList from "../../components/CarModelList";
import CarTypeList from "../../components/CarTypeList";
import ColorList from "../../components/ColorList";
import OptionList from "../../components/OptionList";

function SelledCarManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">차량 관리</h3>
                <ColorList />
                <OptionList />
                <CarCategoryList />
                <CarModelList categoryId={""} />
                <CarTypeList modelId={""} />
            </Space>
        </div>
    );
}

export default SelledCarManagement;
